import { Component, inject } from '@angular/core';
import { SeoManager } from '../../core/services/seo/seo-manager';

@Component({
  selector: 'app-privacy',
  imports: [],
  templateUrl: './privacy.html',
  styleUrl: './privacy.scss',
})
export class Privacy {
  private seoManager = inject(SeoManager);

  constructor() {
    this.seoManager.updateSeoTags({
      title: 'Términos y condiciones',
      description: 'Lea nuestros términos y condiciones de uso.',
    });
  }
}
